import React, { useLayoutEffect, useState } from 'react';
import {
  ActivityAssociation,
  DataVendor,
  ProposalEntitySubmittedBy,
  SearchEntity,
} from 'v2/models';
import InteractionsActivityForm from './InteractionsActivityForm';
import InteractionsActivityList from './InteractionsActivityList';
import { getContactNameToDisplay } from 'v2/utils/ContactUtils';
import useGetContacts from 'v2/hooks/useGetContacts';

interface ProviderInteractionsModalProps {
  show: boolean;
  onHide: () => void;
  hideIdentity: boolean;
  request: SearchEntity;
  dataVendor: DataVendor;
  submittedBy?: ProposalEntitySubmittedBy;
}

const ProviderInteractionsModal = ({
  show,
  onHide,
  hideIdentity,
  request,
  dataVendor,
  submittedBy,
}: ProviderInteractionsModalProps) => {
  const [showActivityForm, setShowActivityForm] = useState(false);
  const [animation, setAnimation] = useState(true);

  useLayoutEffect(() => {
    if (show) {
      setAnimation(true);
      setShowActivityForm(false);
    }
  }, [show]);

  const { data: contactsResponse } = useGetContacts(
    {
      email: submittedBy?.email,
      data_vendor: dataVendor.id,
    },
    {
      refetchOnWindowFocus: false,
      enabled: !hideIdentity && !!submittedBy,
    },
    0
  );
  const submittedByContact = contactsResponse?.results[0] || undefined;

  const defaultAssociations: ActivityAssociation[] = [
    {
      table_name: 'Searches',
      name: request.name,
      object_id: request.id,
      is_mandatory: true,
    },
  ];

  if (!hideIdentity) {
    defaultAssociations.push({
      table_name: 'DataVendor',
      name: dataVendor.name,
      object_id: dataVendor.id,
      is_mandatory: true,
    });
  }

  if (submittedByContact) {
    defaultAssociations.push({
      table_name: 'Contact',
      name: getContactNameToDisplay(submittedByContact),
      object_id: submittedByContact.id,
      is_mandatory: true,
    });
  }

  return (
    <>
      {showActivityForm ? (
        <InteractionsActivityForm
          defaultAssociations={defaultAssociations}
          onCloseForm={() => setShowActivityForm(false)}
          show={show}
          onHide={onHide}
        />
      ) : (
        <InteractionsActivityList
          relatedObjectId={dataVendor.id}
          defaultAssociations={defaultAssociations}
          onToggleForm={() => setShowActivityForm(true)}
          show={show}
          onHide={onHide}
          animation={animation}
          onEntered={() => setAnimation(false)}
        />
      )}
    </>
  );
};

export default ProviderInteractionsModal;
